// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay-bg[data-v-d2e6b9c4]{position:fixed;overflow:hidden;left:0;right:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
